// composables/useUserLang.js
import { computed } from 'vue'
import { useRequestHeaders } from '#app' // dispo en SSR (Nuxt 3)

export function useUserLang () {
  const supported = ['fr','en','es','de','it','pt','ru','zh']

  const getLang = () => {
    if (process.server) {
      const headers = useRequestHeaders(['accept-language'])
      const al = (headers?.['accept-language'] || '').toLowerCase()
      const b = al.split(',')[0]?.split('-')[0] || 'fr'
      return supported.includes(b) ? b : 'fr'
    }
    // client
    const b = (navigator?.language || 'fr').split('-')[0].toLowerCase()
    return supported.includes(b) ? b : 'fr'
  }

  return computed(getLang)
}
